<template>
  <div>
    <!-- <a class="dropdown-item" v-b-modal="data.account_number + transaction">Cheque</a> -->
    <b-button title="View" class="btn btn-sm akkurate-warning text-white" v-b-modal="data.code + transaction">
      <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'eye']" /></span>
    </b-button>
    <b-modal :id="data.code + transaction" ref="modal" v-model="showModal" size="xl">
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h6 class="akkurate-green fw-bold">Transaction view</h6>
        <b-button variant="white" @click="close()"> &times; </b-button>
      </template>
      <form>
        <div class="row">

          <div class="mb-2 p-2 card col-8">
            <div class="d-flex mt-4 justify-content-center align-items-center justify-content-lg-start gap-3">
              <div class="col text-center">
                <img v-if="imageLoaded" v-bind:src="frontImgUrl" alt="Ghana Card Front" @load="handleImageLoad" style="height: 180px" class="img-fluid text-center gallery-image" />
                <img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Ghana Card Front" style="height: 180px" class="img-fluid text-center gallery-image" />
                <p class="mt-2 akkurate-green fw-bold">
                  GH Card - Front
                </p>
              </div>
              <div class="col text-center">
                <img v-if="imageLoaded" v-bind:src="backImgUrl" alt="Ghana Card Back" @load="handleImageLoad" style="height: 180px" class="img-fluid text-center gallery-image" />
                <img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Ghana Card Back" style="height: 180px" class="img-fluid text-center gallery-image" />
                <p class="mt-2 akkurate-green fw-bold">
                  GH Card - Back
                </p>
              </div>

              <!-- <div class="col text-center">
                <img v-bind:src="data.signature_image_path" alt="Signature" style="height:180px" class="img-fluid text-center gallery-image" />
                <p class="mt-2 akkurate-green fw-bold">Signature</p>
              </div> -->
            </div>
          </div>

          <div class="row col-4 mb-2">
            <div class="col-12 d-flex flex-column flex-sm-row align-items-center align-items-sm-start justify-content-center justify-content-sm-start my-1 pb-1 border-bottom border-gray-200">
              <!-- Profile Picture -->
              <img id="profile-picture" :src="data.passport_pic_path" alt="Member Profile" class="w-auto h-auto rounded-circle object-fit-cover mb-3 mb-sm-0 me-sm-4" style="width: 130px !important; height: 130px !important;">

              <!-- Member Core Details -->
              <div class="text-center text-dark text-sm-start">
                <h1 class="fs-2 fw-bold text-dark mb-1 font-lg " id="member-full-name">{{ getFullName }}
                </h1>
                <p class="text-secondary akkurate-small mb-1 ">Member Code: <span class="fw-medium" id="member-id">{{ data.code }}</span></p>
                <p class="text-secondary akkurate-small mb-2 font-primary">USSD Status: <span class="fw-medium" id="member-status-badge" :class="statusBadge(data.ussd_status || 'INACTIVE')">{{ data.ussd_status ||
                  "INACTIVE" }}</span></p>
                <div class="d-flex align-items-center justify-content-center justify-content-sm-start gap-2">
                  <span id="member-status-badge" :class="statusBadge(data.account.status || '')">{{ data.account.status }}</span>
                  <!-- <div class="dropdown custom-pointer text-end">
										<div title="Status" id="dropdownMenu" class="data-select data-select-sm shadow-sm focus:border-green-500 focus:ring focus:ring-green-200 focus:ring-opacity-50" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											<span class="ms-2 px-3 fw-bold">
												{{ data.status }}
											</span>
										</div>
										<div class="dropdown-menu dropdown-menu-end shadow animated--fade-in" aria-labelledby="dropdownMenu">
											<div class="dropdown-header py-2">Status</div>
											<b-button v-if="data.status != 'Active'" class="dropdown-item" @click="setUserStatus('Active', data)">
												<span class="small">Active</span>
											</b-button>
											<b-button v-if="data.status != 'Inactive'" class="dropdown-item" @click="setUserStatus('Inactive', data)">
												<span class="small">Inactive</span>
											</b-button>
											<b-button v-if="data.status != 'Dormant'" class="dropdown-item" @click="setUserStatus('Dormant', data)">
												<span class="small">Dormant</span>
											</b-button>
										</div>
									</div> -->
                </div>
              </div>
            </div>
            <div class="row col-12 text-dark mt-auto">
              <p class="fw-bolder p-0 ps-4 m-0 mt-2 col-4">
                {{ data.customer.gender?.toUpperCase() }}
              </p>
              <p class="fw-bolder p-0 m-0 ps-1 col-8 mt-auto">
                {{ getBranch }}
              </p>
              <p class="fw-bolder p-0 m-0 ps-4 col-4 font-bold">ADDRESS:</p>
              <p class="text-wrap p-0 m-0 ps-1 col-8">
                {{ data.customer.address }}
              </p>

              <p class="p-0 m-0 ps-4 col-4 font-bold">TEL:</p>
              <p class="col-8 p-0 ps-1 m-0">
                {{ data.customer.mobile }}
              </p>

              <p class="p-0 m-0 ps-4 col-4 font-bold">EMAIL:</p>
              <p class="col-8 p-0 m-0 ps-1">
                {{ data.customer.email }}
              </p>

              <p class="p-0 m-0 ps-4 col-4 font-bold">REG DATE:</p>
              <p class="col-8 p-0 m-0 ps-1">
                {{ new Date(data.customer.registered_date).toDateString() }}
              </p>
              <p class="p-0 m-0 ps-4 col-4 font-bold">STAFF ID:</p>
              <p class="col-8 p-0 m-0 ps-1">
                {{ data.customer.staff_id }}
              </p>
            </div>
          </div>

        </div>
        <!--  -->

        <div class="row">
          <div class="col-md-12">
            <b-card-group deck>
              <b-card>
                <template #header>
                  <div class="py-1">
                    <h6 class="m-0 fw-bold text-green">Transaction Details</h6>
                  </div>
                </template>
                <b-card-body>
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark" for="title">Code</label>
                      <b-form-group id="title" label-for="title">
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="data.code" disabled></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-8">
                      <label class="akkurate-dark" for="title">Fullname</label>
                      <b-form-group id="title" label-for="title">
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getFullName" disabled></b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark">Transfer Amount</label>
                      <b-form-group>
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="trans_amt" disabled></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark" for="search_term">Account Balance</label>
                      <b-form-group id="search_term" label-for="search_term">
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="balance" disabled></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark" for="search_term">Account Number</label>
                      <b-form-group id="search_term" label-for="search_term">
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="data.account.account_number" disabled></b-form-input>
                      </b-form-group>
                    </div>

                    <hr class="col-12" />


                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark">Transaction Mode</label>
                      <b-form-group>
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="data.transaction_mode" disabled></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark">Transaction Type</label>
                      <b-form-group>
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="data.transaction_type" disabled></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="akkurate-dark">Transaction Status</label>
                      <!-- <b-form-group>
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="data.trans_status" disabled></b-form-input>
                      </b-form-group> -->
                      <p class="m-0 mt-2">
                        <span :class="transStatusBadge(
                          data.trans_status
                        )
                          ">{{ data.trans_status }}</span>
                      </p>
                    </div>

                    <div class="col-12 col-md-6">
                      <label class="akkurate-dark" for="reg_date">Transaction Date</label>
                      <b-form-group id="reg_date" label-for="reg_date">
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="formatDateAndTime(data.trans_date)" disabled></b-form-input>
                      </b-form-group>
                    </div>



                    <div class="col-12 col-md-6">
                      <label class="akkurate-dark">Created At</label>
                      <b-form-group>
                        <b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="formatDateAndTime(data.created_at)" disabled></b-form-input>
                      </b-form-group>
                    </div>

                    <hr class="col-12" />

                    <div class="col-12">
                      <label class="akkurate-dark">Narration</label>
                      <b-form-group>
                        <b-form-textarea class="field-container fields mt-2" id="textarea" v-model="data.narration" placeholder="Enter something..." disabled></b-form-textarea>
                      </b-form-group>
                    </div>
                    <div class="col-12 mt-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="p-3 border rounded h-100 mandate-box">
                            <div class="row pt-2">
                              <div class="col-md-12">
                                <b-form-group label="Mandate">
                                  <b-form-radio-group v-model="getMandate">
                                    <b-form-radio :value="1" class="pt-2" disabled>ANY OF THE FOLLOWING</b-form-radio>
                                    <b-form-radio :value="2" class="pt-2" disabled>ANY TWO OF THE FOLLOWING</b-form-radio>
                                    <b-form-radio :value="3" class="pt-2" disabled>ALL OF THE FOLLOWING</b-form-radio>
                                    <b-form-radio :value="4" class="pt-2" disabled>THE PRINCIPAL SIGNATORY AND ANY OTHER</b-form-radio>
                                  </b-form-radio-group>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 d-flex flex-column">
                          <div class="p-3 border rounded flex-grow-1 signature-box d-flex justify-content-center align-items-center">
                            <img v-bind:src="data.signature_image_path" alt="Signature" style="height: 200px" class="img-fluid" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ? -->
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>

            <div class="pt-2" v-if="data?.attachment">
              <AttachmentPreview :file="data?.attachment" />
            </div>
          </div>
        </div>

      </form>
      <template #modal-footer>
        <div class="w-100">
          <!-- begin loader -->
          <!-- <beat-loader-component 
               class="float-left"
               v-if="isLoading"
               :isLoading="isLoading"
               ></beat-loader-component> -->
          <!-- end loader -->
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <!-- <div class="d-none">{{ getView }}</div> -->
          <b-button @click="$bvModal.hide(data.code + transaction)" type="button" class="akkurate-green-btn modal-btn-width ms-2 float-right"><span class="small"> Okay</span></b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import AttachmentPreview from "@/views/components/AttachmentPreview.vue";
// import ApiService from "@/core/services/api.service";

export default {
  components: {
    SidebarView,
    TopbarView,
    Multiselect,
    AttachmentPreview,
  },
  data() {
    return {
      showModal: false,
      trans_amt: this.data.currency + " " + this.data.trans_amount,
      balance: this.data.currency + " " + this.data.account.account_balance,
      imageLoaded: false,
      frontImgUrl: "",
      backImgUrl: "",
    };
  },
  props: ["data", "transaction"],
  computed: {
    getFullName() {
      // console.log(this.data)
      return this.data.customer.first_name + " " + this.data.customer.last_name;
    },
    getBranch() {
      const branch = this.data.branch?.name
        ? this.data.branch?.name
        : "";
      return branch;
    },
    getMandate() {
      const mandate = this.data?.mandate ? this.data?.mandate : 0;
      return mandate;
    }
  },
  methods: {
    statusBadge(item) {
      // if (item.get_pending_request_member_edit.length > 0) {
      // 	
      // }
      const stat = item.toLowerCase()
      if (item.length == 0) {
        return 'badge akkurate-custom-mid-green'
      }
      if (stat === 'active') {
        return 'badge akkurate-green-bg'
      } else if (stat === 'inactive') {
        return 'badge akkurate-danger-bg'
      } else if (stat === 'dormant') {
        return 'badge akkurate-danger-bg'
      } else if (stat === 'pending') {
        return 'badge akkurate-warning-bg'
      } else {
        return 'badge akkurate-warning-bg'
      }
    },
    transStatusBadge(item) {
      if (item === 'COMPLETED') {
        return 'badge akkurate-green-bg'
      } else if (item === 'FAILED') {
        return 'badge akkurate-danger-bg'
      } else if (item === 'REVERSED') {
        return 'badge akkurate-danger-bg'
      } else if (item === 'PENDING') {
        return 'badge akkurate-warning-bg'
      } else {
        return 'badge akkurate-warning-bg'
      }
    },
    handleImageLoad() {
      if (this.data.customer?.gh_card_front_path) {
        this.imageLoaded = true;
        this.frontImgUrl = this.data.customer?.gh_card_front_path;
      }
      if (this.data.customer?.gh_card_back_path) {
        this.imageLoaded = true;
        this.backImgUrl = this.data.customer?.gh_card_back_path;
      }
    },
    // getAccountView() {
    //     //   getFromServer(this.serverParams).then(response => {
    //     //      this.totalRecords = response.totalRecords;
    //     //      this.rows = response.rows;
    //     //   });
    //     this.isLoading = true;
    //     ApiService.get("/accounts/view/" + this.account_number)
    //         .then(response => {
    //             console.log(response.data.account)
    //             this.data = response.data.account;
    //             this.customer = response.data.account.customer
    //             this.full_name = this.customer.first_name + ' ' + this.customer.last_name;
    //             this.branch = response.data.account.branch;
    //             // this.per_page = response.data.meta.per_page;
    //             // console.log(response.data.meta.per_page)
    //             // this.totalRecords = response.data.meta.total;
    //         }).catch(() => {
    //             // console.log(error);
    //         })
    //         .finally(() => {
    //             // this.isLoading = false
    //         });
    // },
  },
};
</script>